import {
    CREATE_STITCHING_DC_FAILURE,
    CREATE_STITCHING_DC_REQUEST,
    CREATE_STITCHING_DC_SUCCESS,
    CREATE_USER_FORM_STITCHING_DC,
    FETCH_SINGLE_STITCHING_DC_FAILURE,
    FETCH_SINGLE_STITCHING_DC_REQUEST,
    FETCH_SINGLE_STITCHING_DC_SUCCESS,
    FETCH_STITCHING_DC_FAILURE,
    FETCH_STITCHING_DC_REQUEST,
    FETCH_STITCHING_DC_SUCCESS,
    NAVIGATE_STITCHING_DC_DETAILS,
    NAVIGATE_STITCHING_DC,
    STITCHING_DC_USERFORM_RESET,
    UPDATE_STITCHING_DC_FAILURE,
    UPDATE_STITCHING_DC_REQUEST,
    UPDATE_STITCHING_DC_SUCCESS,
    DELETE_STITCHING_DC_REQUEST,
    DELETE_STITCHING_DC_SUCCESS,
    DELETE_STITCHING_DC_FAILURE,
    STITCHING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    STITCHING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    FETCH_YARN_PO_IN_STITCHING_DC_REQUEST,
    FETCH_YARN_PO_IN_STITCHING_DC_SUCCESS,
    FETCH_YARN_PO_IN_STITCHING_DC_FAILURE,
    FETCH_STITCHING_DC_INVOICE_REQUEST,
    FETCH_STITCHING_DC_INVOICE_SUCCESS,
    FETCH_STITCHING_DC_INVOICE_FAILURE,
    RESET_STITCHING_DC_INVOICE,
    NAVIGATE_STITCHING_WITH_ACC,
    NAVIGATE_STITCHING_WITH_ACC_LAST,
    NAVIGATE_STITCHING_WITH_ACC_INITIAL,
    FETCH_STITCHING_DC_ACCESSORIES_REQUEST,
    FETCH_STITCHING_DC_ACCESSORIES_SUCCESS,
    FETCH_STITCHING_DC_ACCESSORIES_FAILURE,
    FETCH_STITCHING_DC_BARCODE_REQUEST,
    FETCH_STITCHING_DC_BARCODE_SUCCESS,
    FETCH_STITCHING_DC_BARCODE_FAILURE,
    UNIT_ID_WITH_PREV_CONSTANT_VALUE,
    RESET_STITCHING_ACC_PRINT,
    RESET_BARCODE_DC_INVOICE,
    FETCH_STITCHING_DC_PRINT_BARCODE_SUCCESS,
    FETCH_STITCHING_DC_PRINT_BARCODE_FAILURE,
    FETCH_STITCHING_DC_PRINT_BARCODE_REQUEST,
    HEADER_SEARCH_CALL_ONLOAD,
    NAVIGATE_STITCHING_DC_PRINT,
    FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_SUCCESS,
    FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_REQUEST,
    FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_FAILURE,
    FETCH_IN_STITCHING_DC_REPORTS_SUCCESS,
    FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_SUCCESS,
    FETCH_IN_STITCHING_DC_REPORTS_REQUEST,
    FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_REQUEST,
    FETCH_IN_STITCHING_DC_REPORTS_FAILURE,
    FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_FAILURE,
    RESET_STITCHING_DC_REPORTS,
    UPDATE_ACTION_IN_STITCHING_DC_REPORTS,
} from './stitchingDC.actionsType';

export const STITCHING_DC = 'stitchingDC';

let initialState = {
    loading: false,
    stitchingDC: [],
    yarnPOInStitchingDC: [],
    stitchingDCInvoice: [],
    stitchingDCInvoiceV2: [],
    detailTextVar: 'details',
    supplierListBasedOnProgram: [],

    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: true,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldRoundoff: 0,
        // stDate: new Date().setMonth(new Date().getMonth() - 1),
        // enDate: new Date(),
    },
    selectedTeam: {},
    detailsId: '',
    activeKey: 1,
    isStitchingDC: false,
    stitchingDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    activeKeyDetail: '1',
    unitDropId: '1',
    headerSearchCall: true,
    foldingFabricPrintGet: []
};

export let stitchingDCReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_STITCHING_DC_REQUEST:
        case FETCH_YARN_PO_IN_STITCHING_DC_REQUEST:
        case CREATE_STITCHING_DC_REQUEST:
        case FETCH_STITCHING_DC_INVOICE_REQUEST:
        case FETCH_STITCHING_DC_ACCESSORIES_REQUEST:
        case FETCH_STITCHING_DC_BARCODE_REQUEST:
        case FETCH_SINGLE_STITCHING_DC_REQUEST:
        case UPDATE_STITCHING_DC_REQUEST:
        case DELETE_STITCHING_DC_REQUEST:
        case FETCH_STITCHING_DC_PRINT_BARCODE_REQUEST:
        case FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_REQUEST:
        case FETCH_IN_STITCHING_DC_REPORTS_REQUEST:
        case FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_STITCHING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingDC: updatePayload
            };
        case FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_SUCCESS:
            return {
                ...state,
                foldingFabricPrintGet: updatePayload
            }
        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }
        case NAVIGATE_STITCHING_DC_PRINT:
            return {
                ...state,
                isStitchingDC: false,
                loading: false,
                stitchingDCSelectedValue: updatePayload.stitchingDCSelectedValue
            };
        case NAVIGATE_STITCHING_WITH_ACC_INITIAL:
            return {
                ...state,
                activeKeyDetail: '1'
            }
        case UNIT_ID_WITH_PREV_CONSTANT_VALUE:
            return {
                ...state,
                unitDropId: payload
            }
        case FETCH_IN_STITCHING_DC_REPORTS_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingDCReports: updatePayload || []
            }
        case UPDATE_ACTION_IN_STITCHING_DC_REPORTS:
            return {
                ...state,
                loading: false,
                stitchingDCReports: payload || []
            }
        case FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingDCReportsProduction: updatePayload.FRC || []
            }
        case RESET_STITCHING_DC_REPORTS:
            return {
                ...state,
                stitchingDCReports: []
            }
        case FETCH_STITCHING_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingDCInvoice: updatePayload,
                stitchingDCInvoiceV2: updatePayload,
            };
        case FETCH_STITCHING_DC_BARCODE_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingBarcode: updatePayload
            };
        case FETCH_STITCHING_DC_PRINT_BARCODE_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingBarcodePrint: updatePayload || []
            }
        case FETCH_STITCHING_DC_ACCESSORIES_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingAccessories: updatePayload || []
            };



        case RESET_STITCHING_ACC_PRINT:
            return {
                ...state,
                loading: false,
                stitchingAccessories: []
            }

        case FETCH_YARN_PO_IN_STITCHING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnPOInStitchingDC: updatePayload?.PONO
            };
        case NAVIGATE_STITCHING_WITH_ACC:
            return {
                ...state,
                loading: false,
                activeKeyDetail: '2'
            }
        case CREATE_STITCHING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,

                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_STITCHING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                userform: updatePayload
            };
        case UPDATE_STITCHING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,

                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case DELETE_STITCHING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,

                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };

        case FETCH_STITCHING_DC_PRINT_BARCODE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload,
                stitchingBarcodePrint: []
            }
        case FETCH_STITCHING_DC_ACCESSORIES_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload,
                stitchingAccessories: []
            }
        case FETCH_STITCHING_DC_FAILURE:
        case FETCH_YARN_PO_IN_STITCHING_DC_FAILURE:
        case FETCH_SINGLE_STITCHING_DC_FAILURE:
        case CREATE_STITCHING_DC_FAILURE:
        case UPDATE_STITCHING_DC_FAILURE:
        case DELETE_STITCHING_DC_FAILURE:
        case FETCH_STITCHING_DC_INVOICE_FAILURE:
        case FETCH_STITCHING_DC_BARCODE_FAILURE:
        case FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_FAILURE:
        case FETCH_IN_STITCHING_DC_REPORTS_FAILURE:
        case FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };


        case CREATE_USER_FORM_STITCHING_DC:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case STITCHING_DC_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_STITCHING_DC_DETAILS:
            return {
                ...state,
                isStitchingDC: true,
                detailTextVar: payload,
                stitchingDCSelectedValue: updatePayload.stitchingDCSelectedValue
            };

        case NAVIGATE_STITCHING_DC:
            return {
                ...state,
                isStitchingDC: false,
                detailTextVar: 'details',

            };
        case RESET_STITCHING_DC_INVOICE:
            return {
                ...state,
                stitchingDCInvoice: []
            };
        case RESET_BARCODE_DC_INVOICE:
            return {
                ...state,
                stitchingBarcode: [],
                stitchingBarcodePrint: []
            }
        case STITCHING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2,
            };
        case NAVIGATE_STITCHING_WITH_ACC_LAST:
            return {
                ...state,
                loading: false,
                activeKeyDetail: '3'
            }
        case STITCHING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,

                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0,
                    // enDate: new Date(),
                    // stDate: new Date().setMonth(new Date().getMonth() - 1)
                },
                activeKey: 1,

            };
        default:
            return state;
    }
};
